module.exports = __webpack_public_path__ + "img/icon2.5a3fc68d.svg";